// src/components/TransactionSettings.js
import React from 'react';
import { useAppContext } from '../context/AppContext';

const TransactionSettings = () => {
    const {
        transactionBlockingEnabled,
        toggleTransactionBlocking
    } = useAppContext();

    return (
        <div className="bg-white rounded-lg shadow-md p-6 mt-6">
            <h2 className="text-xl font-semibold mb-4">Financial Pain Settings</h2>

            <div className="space-y-6">
                <div>
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="font-medium text-gray-800">Require Transaction Acknowledgment</h3>
                            <p className="text-sm text-gray-600 mt-1">
                                When enabled, this feature makes you acknowledge and feel the "pain" of credit card transactions
                                before accessing other parts of the app, making spending more tangible.
                            </p>
                        </div>

                        <div className="ml-4">
                            <label className="inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={transactionBlockingEnabled}
                                    onChange={() => toggleTransactionBlocking(!transactionBlockingEnabled)}
                                    className="sr-only peer"
                                />
                                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900">
                                    {transactionBlockingEnabled ? 'Enabled' : 'Disabled'}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="border-t border-gray-200 pt-4">
                    <h3 className="font-medium text-gray-800">Why This Matters</h3>
                    <p className="text-sm text-gray-600 mt-1">
                        Credit cards create a psychological disconnect between spending and payment. Research shows that people
                        spend more with credit cards than with cash because the "pain of paying" is delayed.
                    </p>
                    <p className="text-sm text-gray-600 mt-2">
                        This feature helps bridge that gap by making you acknowledge spending as it happens, helping to maintain
                        your financial discipline and stay on track with your medical school repayment goal.
                    </p>
                </div>

                <div className="border-t border-gray-200 pt-4">
                    <h3 className="font-medium text-gray-800">How It Works</h3>
                    <ol className="list-decimal list-inside text-sm text-gray-600 mt-1 space-y-1">
                        <li>New credit card transactions are detected via Monarch Money.</li>
                        <li>You'll be prompted to acknowledge each transaction with the "pain slider".</li>
                        <li>The app will connect each transaction to your budget categories.</li>
                        <li>You cannot access other parts of the app until pending transactions are acknowledged.</li>
                    </ol>
                </div>
            </div>
        </div>
    );
};

export default TransactionSettings;